module.exports = __webpack_public_path__ + "img/edit_task.cffb2fa8.svg";